module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-lg bol-create-modal\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <h3 class=\"modal-title\">Create New BOL</h3> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> </section> <section class=\"modal-body\"> <form> <div id=\"estimated_delivery\" class=\"mb-4\"></div> <div id=\"warehouse_location\" class=\"mb-4\"></div> <div id=\"tracking_code\" class=\"mb-4 form-group\"> <label>Tracking Code</label> <input type=\"text\" class=\"form-control\" placeholder=\"Tracking Code (optional)\" name=\"tracking_code\"> </div> <div id=\"attach_csv\" class=\"mb-3 d-inline-block\"></div> </form> </section> <section class=\"modal-footer\"> ")
    ;  if (locals.loading) { 
    ; __append(" <div id=\"bol_upload_loader\" class=\"loader my-4\"> </div> ")
    ;  } else { 
    ; __append(" <a class=\"mr-auto small\" href=\"/how-do-i-create-a-bol.html\" target=\"_blank\">How to fill out a BOL</a> <button type=\"button\" class=\"btn btn-link cancel mr-2\">Cancel</button> <button class=\"btn btn-primary create_bol\" type=\"button\">Create BOL</button> ")
    ;  } 
    ; __append(" </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/fulfillment_bols/create/modal/template.ejs
// module id = 1664
// module chunks = 1